export default __webpack_public_path__ + "static/media/gallery_06.121a2b04.jpg";